export default "__VITE_ASSET__CAYMyka$__"